import api from "./apiConfig.js";

export const CHECK_SESSION = async () => {
	try {
		const token = localStorage.getItem("token");
		const response = await api.get("/check-session", {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error("Sesión no válida.");
		}
	} catch (error) {
		console.error("Error al verificar la sesión:", error);
		throw error;
	}
};

export const LOGIN = async (email, password) => {
	try {
		const response = await api.post("/auth", { email, password });
		return response.data;
	} catch (error) {
		if (error.response.status === 401) {
			console.error(error);
		} else {
			console.error(error);
		}
	}
};
